import React from "react";
import { MONTHLY } from "../../../../config";
import MonthlyDashboard from "./MonthlyDashboard";
import YearlyDashboard from "./YearlyDashboard";

export default function CashFlow({
  dateOrder,
  prefix,
}) {

  return (
    <div>
      <div className="overflow-auto">
        {prefix === MONTHLY ? <MonthlyDashboard dateOrder={dateOrder} /> : <YearlyDashboard dateOrder={dateOrder} />}
      </div>
    </div>
  );
}